export default __webpack_public_path__ + "static/media/input_agency-step1.35e56e12.webp";